import type { SortingState } from '@tanstack/react-table';
import type { OdataQueryBuilder, OrderByDescriptor } from 'odata-builder';
import { z } from 'zod';

export const sortingStateSchema = z.array(
	z.object({
		id: z.string(),
		desc: z.boolean(),
	}),
) satisfies z.ZodType<SortingState>;

export function applyOdataSorting<T>({
	builder,
	map = {},
	sorting,
	defaultSort = [],
}: {
	builder: OdataQueryBuilder<T>;
	map?: Record<string, keyof T>;
	sorting?: SortingState;
	defaultSort?: OrderByDescriptor<Required<T>>[];
}) {
	if (sorting) {
		for (const s of sorting) {
			builder.orderBy({
				field: map[s.id] ?? (s.id as keyof T),
				orderDirection: s.desc ? 'desc' : 'asc',
			} as OrderByDescriptor<Required<T>>);
		}
	} else {
		builder.orderBy(...defaultSort);
	}
}
